import { PureComponent } from 'react';
import { trackEvent } from '../../util/analytics';

export default class ContentExperiment extends PureComponent {
  state = {
    variationIndex: null,
  };

  componentDidMount() {
    const contentExperimentsAPI =
      typeof window === 'object' ? window.cxApi : null;
    if (contentExperimentsAPI && contentExperimentsAPI.chooseVariation) {
      this.setState({
        variationIndex: contentExperimentsAPI.chooseVariation(),
      });

      // If this occurs after the google analytics plugin records the page
      // view (which it probably does), then we need to send some sort of
      // activity to Google Analytics for it to record the result of the
      // experiment. Here we use a "non-interactive" event.
      // https://developers.google.com/analytics/solutions/experiments-client-side
      // https://www.lunametrics.com/blog/2014/05/06/noninteraction-events-google-analytics/
      trackEvent({
        category: 'ContentExperiment',
        action: 'Viewed',
        fieldsObject: { nonInteraction: 1 },
      });
    }
  }

  render() {
    const {
      renderVariations,
      renderLoading = () => null,
      renderError = () => null,
    } = this.props;

    const { variationIndex } = this.state;

    if (variationIndex === null) {
      return renderLoading({ renderVariations });
    }

    if (
      !renderVariations ||
      typeof renderVariations[variationIndex] !== 'function'
    ) {
      return renderError({ renderVariations, variationIndex });
    }

    return renderVariations[variationIndex]();
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentExperiment/ContentExperiment.jsx